import React from 'react';
import { composeLyrics } from '../mvData';

export default function DependencySummary({ vm, t }) {
  return (
    <div className="mv-summary-list">
      {vm.step !== 'lyrics' && vm.lyrics.length > 0 && (
        <SummaryCard
          title={t('videoGeneration.mv.summary.lyricsTitle')}
          text={firstLyricLine(vm.lyrics)}
          action={t('videoGeneration.mv.summary.editLyrics')}
          onAction={() => vm.setStep('lyrics')}
        />
      )}
      {vm.step === 'video' && vm.music && (
        <SummaryCard
          title={t('videoGeneration.mv.summary.musicTitle')}
          text={`${vm.music.title} · ${vm.music.meta}`}
          action={t('videoGeneration.mv.summary.editMusic')}
          onAction={() => vm.setStep('music')}
        />
      )}
    </div>
  );
}

function SummaryCard({ title, text, action, onAction }) {
  return (
    <article className="mv-summary">
      <div><strong>{title}</strong><span>{text}</span></div>
      <button onClick={onAction}>{action}</button>
    </article>
  );
}

function firstLyricLine(sections) {
  const lyric = composeLyrics(sections).split('\n').find((line) => !line.startsWith('['));
  return lyric || '';
}
